import { render, staticRenderFns } from "./XydPdfAgreement.vue?vue&type=template&id=507e98e2&scoped=true"
import script from "./XydPdfAgreement.vue?vue&type=script&lang=js"
export * from "./XydPdfAgreement.vue?vue&type=script&lang=js"
import style0 from "./XydPdfAgreement.vue?vue&type=style&index=0&id=507e98e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507e98e2",
  null
  
)

export default component.exports